module.exports = __webpack_public_path__ + "static/media/OFmidterm.ded16a55.png";